import React from 'react';
import { motion } from 'framer-motion';
import { AboutDirector } from '../components/AboutDirector';
export function People() {
  return <div className="bg-[#FAF9F7] min-h-screen pb-24" data-id="element-349">
      {/* Page Header */}
      <div className="bg-[#4A0000] py-16 text-center" data-id="element-350">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl font-bold text-white font-serif" data-id="element-351">
          Our People
        </motion.h1>
      </div>

      {/* Faculty Section */}
      <div className="mt-12" data-id="element-352">
        <div className="text-center mb-8" data-id="element-353">
          <h2 className="text-3xl font-bold text-[#800000] font-serif inline-block relative" data-id="element-354">
            Faculty Member
            <span className="absolute -bottom-3 left-1/4 right-1/4 h-0.5 bg-[#800000]" data-id="element-355"></span>
          </h2>
        </div>
        <AboutDirector data-id="element-356" />
      </div>

      {/* Students Placeholder Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-24" data-id="element-357">
        <div className="text-center mb-16" data-id="element-358">
          <h2 className="text-3xl font-bold text-[#800000] font-serif inline-block relative" data-id="element-359">
            Current Students & Researchers
            <span className="absolute -bottom-3 left-1/4 right-1/4 h-0.5 bg-[#800000]" data-id="element-360"></span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-361">
          {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-md transition-shadow text-center p-6" data-id="element-362">
              <div className="w-24 h-24 mx-auto bg-gray-200 rounded-full mb-4 flex items-center justify-center text-gray-400" data-id="element-363">
                Photo
              </div>
              <h3 className="font-bold text-gray-900 font-serif" data-id="element-364">
                Student Name
              </h3>
              <p className="text-sm text-[#800000] font-medium mb-2" data-id="element-365">
                Ph.D. Scholar
              </p>
              <p className="text-xs text-gray-500" data-id="element-366">
                Research Area: Multiphase Flow
              </p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}